import { useChainId } from 'wagmi'

import { EasyBorrowSkeleton } from './components/skeleton/EasyBorrowSkeleton'
import { useEasyBorrow } from './logic/useEasyBorrow'
import { EasyBorrowView } from './views/EasyBorrowView'
import { SuccessView } from './views/SuccessView'
import { useConnectModal } from '@/domain/hooks/wallet'
import { withSuspense } from '@/ui/utils/withSuspense'

function EasyBorrowContainer() {
  const {
    form,
    assetsToDepositFields,
    assetsToBorrowFields,
    updatedPositionSummary,
    setDesiredLoanToValue,
    liquidationDetails,
    pageStatus,
    tokensToDeposit,
    tokensToBorrow,
    alreadyDeposited,
    alreadyBorrowed,
    borrowDetails,
    guestMode,
    openSandboxModal,
    focusOnActionsPanel,
    riskAcknowledgement,
    actionsViewState,
  } = useEasyBorrow()
  const { openConnectModal = () => {} } = useConnectModal()

  if (pageStatus.state === 'success') {
    return <SuccessView deposited={tokensToDeposit} borrowed={tokensToBorrow} runConfetti />
  }

  return (
    <EasyBorrowView
      pageStatus={pageStatus}
      form={form}
      assetsToBorrowFields={assetsToBorrowFields}
      assetsToDepositFields={assetsToDepositFields}
      alreadyDeposited={alreadyDeposited}
      alreadyBorrowed={alreadyBorrowed}
      updatedPositionSummary={updatedPositionSummary}
      setDesiredLoanToValue={setDesiredLoanToValue}
      liquidationDetails={liquidationDetails}
      borrowDetails={borrowDetails}
      guestMode={guestMode}
      openConnectModal={openConnectModal}
      openSandboxModal={openSandboxModal}
      focusOnActionsPanel={focusOnActionsPanel}
      riskAcknowledgement={riskAcknowledgement}
      actionsViewState={actionsViewState}
    />
  )
}

// @note: forces form to reset when network changes
function EasyBorrowContainerWithKey() {
  const chainId = useChainId()
  return <EasyBorrowContainer key={chainId} />
}

const EasyBorrowContainerWithSuspense = withSuspense(EasyBorrowContainerWithKey, EasyBorrowSkeleton)

export { EasyBorrowContainerWithSuspense as EasyBorrowContainer }
